import Vue from 'vue'

var eventBus = new Vue({})

eventBus.initEvent = function (context, event, methods) {
	eventBus.$on(event, methods)
	context.$once('hook:beforeDestroy', function () {
		eventBus.$off(event, methods)
	})
}

eventBus.refreshPage = function () {
	eventBus.$emit('fxRefreshPage')
}

export default eventBus



// WEBPACK FOOTER //
// ./src/lib/plugin/src/eventBus.js